import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { retrieveOrderPricesApi } from "../../../../components/api/OrderApiService"; // fixed relative path

const PriceDialog = ({ open, onClose, title, orderType, itemId }) => {
  const [prices, setPrices] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    if (!itemId) {
      setPrices([]);
      return;
    }
    setLoading(true);
    retrieveOrderPricesApi(orderType, itemId)
      .then((res) => {
        setPrices(res.data || []);
      })
      .catch(() => {
        toast.error("Failed to load prices.");
        setPrices([]);
      })
      .finally(() => setLoading(false));
  }, [open, itemId, orderType]);

 return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {loading ? (
          <Typography sx={{ p: 2 }}>Loading...</Typography>
        ) : (
          <TableContainer component={Paper} variant="outlined" sx={{ mt: 1 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Purchase Order</TableCell>
                  <TableCell>Sales Order</TableCell>
                  <TableCell align="right">Quantity</TableCell>
                  <TableCell align="right">Final Price</TableCell>
                  <TableCell align="right">USD Final Price</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {prices && prices.length > 0 ? (
                  <>
                    {prices.map((row, i) => (
                      <TableRow key={i}>
                        <TableCell>{row.id}</TableCell>
                        <TableCell> {orderType === "CUSTOMER"
                            ? ""                        
                            : row.purchaseOrderNumber || ""}</TableCell>
                        <TableCell>{row.salesOrderNumber}</TableCell>
                        <TableCell align="right">
                          {row.volume != null
                            ? new Intl.NumberFormat("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(Number(row.volume))
                            : "-"}
                        </TableCell>
                        <TableCell align="right">
                          {row.finalPrice != null
                            ? new Intl.NumberFormat("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(Number(row.finalPrice))
                            : "-"}
                        </TableCell>
                        <TableCell align="right">
                          {row.usdFinalPrice != null
                            ? new Intl.NumberFormat("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(Number(row.usdFinalPrice))
                            : "-"}
                        </TableCell>
                      </TableRow>
                    ))}
                    {/* Mean row */}
                    <TableRow>
                      <TableCell colSpan={4} align="right">
                        Mean Price (per kg):
                      </TableCell>
                      <TableCell align="right">
                        {new Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(
                          prices.length > 0
                            ? prices.reduce(
                                (sum, r) =>
                                  sum + (Number(r.finalPrice) || 0),
                                0
                              ) / prices.length
                            : 0
                        )}
                      </TableCell>
                      <TableCell align="right">
                        {new Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(
                          prices.length > 0
                            ? prices.reduce(
                                (sum, r) =>
                                  sum + (Number(r.usdFinalPrice) || 0),
                                0
                              ) / prices.length
                            : 0
                        )}
                      </TableCell>
                    </TableRow>
                  </>
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No records found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} size="small">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PriceDialog;